export default __webpack_public_path__ + "static/media/logoSpinner2.7512cce3.png";